import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f9c83ee")

_pushScopeId("data-v-3f9c83ee")
const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("管控模式为：暂停")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("直接移除")
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "danger-tip" }, " 谨慎操作", -1)
const _hoisted_5 = { class: "import-actions" }
const _hoisted_6 = {
  key: 0,
  class: "preview-stat"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "transfer-tip" }, "如相同设备型号，不存在则新增，存在则更新", -1)
const _hoisted_8 = { class: "footer-btns" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_c_upload = _resolveComponent("c-upload")
  const _component_c_export_file = _resolveComponent("c-export-file")
  const _component_el_form = _resolveComponent("el-form")
  const _component_c_table = _resolveComponent("c-table")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _ctx.formData,
      "label-width": "110px",
      class: "transfer-form"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, { label: "源企业" }, {
          default: _withId(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.sourceCompanyUuid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.sourceCompanyUuid = $event)),
              placeholder: "请输入",
              clearable: "",
              filterable: "",
              remote: "",
              "remote-method": _ctx.remoteData1.remoteMethod,
              loading: _ctx.remoteData1.isLoading
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.remoteData1.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "remote-method", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "源企业设备设置" }, {
          default: _withId(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.removeSource,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.removeSource = $event))
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio, {
                  label: _ctx.removeSourceEnum.设为暂停
                }, {
                  default: _withId(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_radio, {
                  label: _ctx.removeSourceEnum.直接移除
                }, {
                  default: _withId(() => [
                    _hoisted_3,
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "目标企业" }, {
          default: _withId(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.targetCompanyUuid,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.targetCompanyUuid = $event)),
              placeholder: "请输入",
              clearable: "",
              filterable: "",
              remote: "",
              "remote-method": _ctx.remoteData2.remoteMethod,
              loading: _ctx.remoteData2.isLoading
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.remoteData2.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "remote-method", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "导入文件" }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_c_upload, {
                action: _ctx.previewAction,
                headers: _ctx.uploadHeaders,
                data: _ctx.uploadData,
                multiple: false,
                accept: ".xlsx",
                limit: 1,
                maxSize: 3072,
                "btn-text": "上传模板文件",
                "is-tip": false,
                disabled: !_ctx.formData.sourceCompanyUuid || !_ctx.formData.targetCompanyUuid,
                onOnSuccess: _ctx.onUploadSuccess,
                onOnRemove: _ctx.onUploadRemove
              }, null, 8, ["action", "headers", "data", "disabled", "onOnSuccess", "onOnRemove"]),
              _createVNode(_component_c_export_file, {
                class: "download-btn",
                url: "/device/terminal/transferTemplate",
                "btn-type": "text",
                "btn-text": "下载模板文件",
                "btn-icon": "",
                "file-title": _ctx.transferFileName,
                "file-type": "xlsx",
                "is-confirm": false
              }, null, 8, ["file-title"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (_ctx.previewData)
      ? (_openBlock(), _createBlock("div", _hoisted_6, " 根据导入的文件查找目标企业，车辆数：" + _toDisplayString(_ctx.previewData.sourceCarCount) + " 辆 匹配车载设备 " + _toDisplayString(_ctx.previewData.matchedDeviceCount) + " 个 ", 1))
      : _createCommentVNode("", true),
    _createVNode(_component_c_table, { dataSource: _ctx.tableConfig }, null, 8, ["dataSource"]),
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.tableConfig.data.length,
        onClick: _ctx.handleConfirm
      }, {
        default: _withId(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_el_button, { onClick: _ctx.handleCancel }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})